import React from "react";
import Logo from "../../images/logo.svg";
import { useLocation , useNavigate} from "react-router-dom";
import "./Header.scss";
const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const q = queryParams.get("q");
  const handleLogoClick = () => {
    if (q) {
      navigate(`/?q=${encodeURIComponent(q)}`);
    } else {
      navigate("/");
    }
  };
  return (
    <header>
      <div className="link">
        <button onClick={handleLogoClick}>
          <figure>
            <img src={Logo} alt="logo" />
          </figure>
        </button>
      </div>
    </header>
  );
};

export default Header;
